import { render, staticRenderFns } from "./TableMemberships.vue?vue&type=template&id=36dee2d1&"
import script from "./TableMemberships.vue?vue&type=script&lang=js&"
export * from "./TableMemberships.vue?vue&type=script&lang=js&"
import style0 from "./TableMemberships.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports